import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/software/SoftwareProductLayout.tsx");
